export default __webpack_public_path__ + "static/media/cropped-MetriMeo-Blue-300x78.065c3bfe.png";